;(function () {
  angular
    .module('contrast.protect.rules')
    .controller('ModalProtectionRuleModalCtrl', ModalProtectionRuleModalCtrl)

  function ModalProtectionRuleModalCtrl(
    $scope,
    $uibModalInstance,
    $q,
    $translate,
    logger,
    ProtectionRulesFactory,
    BlockingPerimeterModalService,
    appIds,
    ruleId,
    callback,
    enabledBP,
    canBlock,
    PROTECTION_MODES,
    SERVER_ENVIRONMENT,
    PROTECTION_MODES_ORDINAL
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        dev: undefined,
        qa: undefined,
        prod: undefined,
        modes: PROTECTION_MODES
      }
    })

    angular.extend($scope, {
      update: update,
      cancel: cancel,
      getModes: getModes,
      disableBlocking: disableBlocking
    })

    function update() {
      var promiseConfigs = []

      angular.forEach(appIds, function (appId) {
        if (!angular.isUndefined($scope.model.dev)) {
          promiseConfigs.push({
            appId: appId,
            ruleId: ruleId,
            env: SERVER_ENVIRONMENT.DEVELOPMENT.value,
            level: PROTECTION_MODES_ORDINAL.indexOf($scope.model.dev)
          })
        }
        if (!angular.isUndefined($scope.model.qa)) {
          promiseConfigs.push({
            appId: appId,
            ruleId: ruleId,
            env: SERVER_ENVIRONMENT.QA.value,
            level: PROTECTION_MODES_ORDINAL.indexOf($scope.model.qa)
          })
        }
        if (!angular.isUndefined($scope.model.prod)) {
          promiseConfigs.push({
            appId: appId,
            ruleId: ruleId,
            env: SERVER_ENVIRONMENT.PRODUCTION.value,
            level: PROTECTION_MODES_ORDINAL.indexOf($scope.model.prod)
          })
        }
      })

      if (
        $scope.model.dev === 'BLOCKING_PERIMETER' ||
        $scope.model.qa === 'BLOCKING_PERIMETER' ||
        $scope.model.prod === 'BLOCKING_PERIMETER'
      ) {
        $uibModalInstance.dismiss()
        BlockingPerimeterModalService.openModal(promiseConfigs, callback, true)
      } else {
        var promises = [],
          i,
          config
        for (i = 0; i < promiseConfigs.length; i++) {
          config = promiseConfigs[i]
          promises.push(
            ProtectionRulesFactory.editEnvProtectionLevel(
              config.appId,
              config.ruleId,
              config.env,
              config.level
            )
          )
        }

        $q.all(promises)
          .then(function () {
            logger.logSuccess(
              $translate.instant('detail_protectionPolicyUpdatedSuccessfully')
            )
            $uibModalInstance.close()
          })
          .catch(function () {
            logger.logError(
              $translate.instant('detail_protectionPolicyNotUpdated')
            )
          })
      }
    }

    function getModes() {
      if (!enabledBP) {
        return $scope.model.modes.filter(function (mode) {
          return mode.value !== 'BLOCKING_PERIMETER'
        })
      } else {
        return $scope.model.modes
      }
    }

    function disableBlocking(mode) {
      if (mode.value === 'BLOCKING' && canBlock === false) {
        return true
      }
      return false
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
